import React, { useEffect, useState } from 'react';
import { Redirect } from 'react-router-dom';

const LicenseCheckWrapper = ({ children }) => {
  const [isLicensed, setIsLicensed] = useState(null);

  useEffect(() => {
    const checkLicense = async () => {
      try {
        const response = await fetch('/api/license/status');
        const data = await response.json();
        setIsLicensed(data.isValid);
      } catch (error) {
        console.error('License check failed:', error);
        setIsLicensed(false);
      }
    };

    checkLicense();
  }, []);

  if (isLicensed === null) {
    // Optionally, render a loading indicator while checking license
    return <div>Loading...</div>;
  }

  return isLicensed ? children : <Redirect to="/site/config" />;
};

export default LicenseCheckWrapper;
